import { AfterViewInit, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { IPkInputDateFieldProps } from './pk-input-date-field.props';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { getFirstError } from '../../../helpers';
import { first } from 'rxjs/operators';

@Component({
  selector: 'pk-date-field',
  templateUrl: './pk-date-field.component.html',
  styleUrls: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PkDateFieldComponent),
      multi: true
    }
  ]
})
export class PkDateFieldComponent implements ControlValueAccessor, OnInit, AfterViewInit {
  public firstError ?: string;

  @Input()
  settings: IPkInputDateFieldProps;

  @Input() _dateValue: string = null;

  propagateChange = (_: any) => {
  };

  get dateValue() {
    if (this._dateValue) {
      return moment(this._dateValue, 'YYYY-MM-DD').toDate();
    }
    return undefined;
  }

  set dateValue(val) {
    this._dateValue = val ? moment(val).format('YYYY-MM-DD') : undefined;
    this.propagateChange(this._dateValue);
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.dateValue = event.value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.dateValue = obj;
  }

  ngOnInit(): void {
    this.firstError = getFirstError(this.settings.formControlName, this.settings.form);
  }

  get invalid() {
    return false;
  }

  ngAfterViewInit(): void {
    //TODO: fucked up
    const formControl = this.settings.form.get(this.settings.formControlName);
    formControl?.valueChanges.pipe(first()).toPromise().then(_ => {
      this.firstError = getFirstError(this.settings.formControlName, this.settings.form);
      formControl?.valueChanges.subscribe((_) => {
        this.firstError = getFirstError(this.settings.formControlName, this.settings.form);
      });
    });

  }
}
